<!-- Node Info -->
@if (currentMap === 'seatmap' || is3dView) {
  <div class="mx-4 text-lugano-white flex justify-center items-center">
    <div class="mx-2 flex items-baseline">
      <p class="me-1 text-sm text-lugano-white/50">Section</p>
      <p class="text-base font-bold">{{ nodeData.section }}</p>
      <!-- <p class="text-base font-bold">{{ nodeData[0] }}</p> -->
    </div>
    @if (is3dView) {
      @if (nodeData.row) {
      <div class="mx-2 flex items-baseline">
        <p class="me-1 text-sm text-lugano-white/50">Row</p>
        <p class="text-base font-bold">{{ nodeData.row }}</p>
      </div>
      }
      @if (nodeData.seat) {
      <div class="mx-2 flex items-baseline">
        <p class="me-1 text-sm text-lugano-white/50">Seat</p>
        <p class="text-base font-bold">{{ nodeData.seat }}</p>
      </div>
      }
    }
  </div>
}